import { createContext, useContext, useReducer } from 'react';

import { contractsReducer, contractsTypes } from './reducer';

/******************************************************************************************
             NOTE: Add any global data for workers contracts  
/*************************************************************************************** */

export type InitialStateType = {
  keyword?: string;
  // addContractValues:
};

const initialState = {
  keyword: '',
};

const ContractsContext = createContext<{
  state: InitialStateType;
  setKeyword: (keyword?: string) => void;
}>({
  state: initialState,
  setKeyword: () => {
    return;
  },
});
//
const ContractsProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [state, dispatch] = useReducer(contractsReducer, initialState);

  const setKeyword = (keyword?: string) => {
    dispatch({ type: contractsTypes.setKeyword, payload: keyword });
  };
  // action creators

  return (
    <ContractsContext.Provider value={{ state, setKeyword }}>
      {children}
    </ContractsContext.Provider>
  );
};
const useContractsContext = () => useContext(ContractsContext);

export { ContractsProvider, useContractsContext };
